import { useNavigate } from "react-router-dom";
import { EventListItemDto } from "../../autogen/bff-api";
import { urls } from "../../urls";

export const useEventNavigation = () => {
  const navigate = useNavigate();
  return (event: EventListItemDto) => navigate(urls.app.sourcingEvents.view.go(event.id));
};
